import React from "react";
import { X } from "lucide-react";

const ErrorScreen = ({ text }) => {
  return (
    <div className="flex flex-col gap-8 items-center h-96 justify-center">
      <div className="w-max p-6 flex justify-center items-center bg-red-600 rounded-[4rem]">
        <X height={56} width={56} stroke="#FFFFFF" />
      </div>
      <h3 className="text-[#2A2F40] text-[2rem] font-satoshi-black">{text}</h3>
    </div>
  );
};

export default ErrorScreen;
